import { render, staticRenderFns } from "./UserViewUserPermissionsCard.vue?vue&type=template&id=1438f038"
import script from "./UserViewUserPermissionsCard.vue?vue&type=script&lang=js"
export * from "./UserViewUserPermissionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports